export const table = {
  primaryData: [
    {
      title: "ID",
      value: "id",
      type: "configue",
    },
    {
      title: "External Session Instance ID",
      value: "externalLiveSessionsInstanceId",
      type: "configue",
    },
    {
      title: "Live Session ID",
      value: "liveSessionId",
      type: "configue",
    },
    {
      title: "Started At",
      value: "startedAt",
      type: "configue",
    },
    {
      title: "Ended At",
      value: "endedAt",
      type: "configue",
    },
    {
      title: "Sort Order",
      value: "sortOrder",
      type: "configue",
    },
    {
      title: "Status",
      value: "status",
      type: "configue",
    },
    {
      title:"Iteration",
      value:"iteration",
      type:"configue"
    },
    {
      title: "Action",
      value: "recordingAction",
      type: "configue",
    },
  ],

  secondaryData: [
    {
      title: "Created At",
      value: "createdAt",
      type: "configue",
    },
    {
      title: "Updated At",
      value: "updatedAt",
      type: "configue",
      name: "updatedAt",
    },
    {
      title: "Created By",
      value: "createdByName",
      type: "configue",
    },
    {
      title: "Updated By",
      value: "updatedByName",
      type: "configue",
      name: "updatedByName",
    },
  ],
};